import {MODULE_DISTRIBUTION_DAO} from '../data/app_dao_module';
import CreateBundleComponent from '../modules/distribution/components/bundle/create/bundle.create.component';
import EditBundleComponent from '../modules/distribution/components/bundle/create/bundle.edit.component';
import {MODULE_DISTRIBUTION_SERVICES} from '../services/app.services.module';
import ServerError from './server_error/server_error.module';

export const MODULE_DISTRIBUTION_STATES = 'distribution.states';
angular.module(MODULE_DISTRIBUTION_STATES, [
    ServerError.name,
    MODULE_DISTRIBUTION_SERVICES,
    MODULE_DISTRIBUTION_DAO,
    'cfp.hotkeys',
    'ui.router'
]).run(changeStateHook);

function changeStateHook($location, $timeout, $rootScope, $q, $state, AppState, JFrogEventBus, User, AppStack, JFrogUIModelSaverFactory) {
    let EVENTS = JFrogEventBus.getEventsDefinition();

     $rootScope.$on('$locationChangeStart', (e, newUrl) => {
         if (JFrogUIModelSaverFactory.confirmDiscardModalOpen) {
             e.preventDefault();
         }
     });

    $rootScope.$on('$stateChangeSuccess', (e, toState, toParams, fromState, fromParams) => {
        AppState.setState(toState,toParams);
    });

     $rootScope.$on('$stateChangeStart', (e, toState, toParams, fromState, fromParams) => {

     	if(!toState.isDistributionState) {
             return;
         }

	     if(toState.name === CreateBundleComponent.META.state.name ||
		     toState.name === EditBundleComponent.META.state.name) {
		     // Save the prev state before going to create RB form
		     AppStack.setItem('preFormState',{state:fromState.name, params:fromParams});
	     }
	     if(fromState.name === CreateBundleComponent.META.state.name
             || fromState.name === EditBundleComponent.META.state.name) {
             if (!JFrogUIModelSaverFactory.confirmDiscardModalOpen) {
			     JFrogUIModelSaverFactory.checkDiscardConfirmation($q, e, fromState.name).then(()=> {
                     $state.go(toState.name, toParams);
			     });
		     } else {
			     e.preventDefault();
			     return;
		     }
	     }

         if (!e.defaultPrevented) {
             JFrogEventBus.dispatch(EVENTS.CLOSE_MODAL);
         }
     });
}

changeStateHook.$inject = [
	'$location',
	'$timeout',
	'$rootScope',
	'$q',
	'$state',
	'AppState',
	'JFrogEventBus',
	'User',
	'AppStack',
	'JFrogUIModelSaverFactory'];



// WEBPACK FOOTER //
// ./modules/distribution/states/app.states.module.js